import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import moment from "moment";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    flexWrap: "wrap",
    marginTop: 13,
    background: "#ffffff",
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: "100%",
  },
}));

export default function DateTimePicker({
  setDate,
  setFromDate,
  setToDate,
  dateMode,
  appointmentDate,
  toDate,
  fromDate,
}) {
  const classes = useStyles();
  const [label, setLabel] = useState("");

  useEffect(() => {
    getLabel();
  }, []);
  const getLabel = () => {
    if (dateMode === "nextAppointment") {
      setLabel("RDV client");
    } else if (dateMode === "fromDate") {
      setLabel("Date de RDV du");
    } else if (dateMode === "toDate") {
      setLabel("Au");
    }
  };

  const callDateFn = (e) => {
    if (dateMode === "nextAppointment") {
      setDate(e.target.value);
    } else if (dateMode === "fromDate") {
      setFromDate(e.target.value);
    } else if (dateMode === "toDate") {
      setToDate(e.target.value);
    }
  };

  return (
    <div className={classes.container} noValidate>
      <TextField
        id="datetime-local"
        label={label}
        type="date"
        defaultValue={
          dateMode !== "toDate" && moment(new Date()).format(`YYYY-MM-DD`)
        }
        className={classes.textField}
        InputLabelProps={{ shrink: true }}
        onChange={callDateFn}
        inputProps={{
          min: moment(new Date()).format(`YYYY-MM-DD`),
        }}
      />
    </div>
  );
}
